import { useEffect, useState } from "react";
import "./distinteDocuments.scss";
import { message, Row, Card, Space, Typography, Col, Button, Flex, Form, Popconfirm, List, Divider } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { Link, useParams } from "react-router-dom";
import { FilePdfOutlined, PlusOutlined, DeleteOutlined, DownloadOutlined, FolderAddOutlined, LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import * as XLSX from 'xlsx-js-style';
import * as FileSaver from "file-saver";
import TextArea from "antd/es/input/TextArea";
import { useCurrentUserContext } from "../../context/currentUserContext.js";
import dayjs from 'dayjs';
import { PageHeader } from "../../components/common/pageHeader.js";
import ContentLoader from "../../components/common/contentLoader.js";
import DistinteDocumentServices from "../../services/distinteDocumentServices.js";
import AddDocumentAttachment from "../documents/newDocumentAttachmentModal.js";
import ReplaceDocumentPdfModal from "../documents/replaceDocumentPdfModal.js";
import { group2Rights, isSuperAdmin } from "../../configs/auth/roleRights.js";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const { Text } = Typography;

const DistinteViewDocument = () => {
  const urlParams = useParams();
  const [form] = Form.useForm();

  const { currentUser } = useCurrentUserContext();
  const [documentData, setdocumentData] = useState(null);
  const [loadingData, setLoadingData] = useState(false);

  const [loadingNotes, setLoadingNotes] = useState(false);
  const [loadingAddNote, setLoadingAddNote] = useState();
  const [documentNotes, setDocumentNotes] = useState("");
  const [loadingNoteRemove, setLoadingNoteRemove] = useState(false);

  const [documentAttachment, setDocumentAttachments] = useState("");
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [loadingAttachmentList, setLoadingAttachmentList] = useState(false);
  const [loadingRemoveAttachment, setLoadingAttachmentDelete] = useState(false);


  const [loadingReplaceDocumentPdf, setLoadingReplaceDocumentPdf] = useState(false);
  const [showDocumentReplacementModal, setShowDocumentReplacementModal] = useState(false);

  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingExportLogs, setLoadingExportLogs] = useState(false);

  useEffect(() => {
    getDocumentDataByID(urlParams.id, currentUser.id);
    getDocumentAttachmentList(urlParams.id);
  }, []);

  const getDocumentDataByID = async (documentId, userId) => {

    setLoadingData(true);
    try {
      const respData = await DistinteDocumentServices.getDocumentDetails(documentId, userId);
      if (respData.success) {
        let result = respData.responseObject.value.documentDetails_Distinte_DTO;
        setdocumentData(result);
        setLoadingData(false);
        getDocumentNotesList(documentId);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingData(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingData(false);
    }
  };

  const handelModalClose = () => {
    setShowAttachmentModal(false);
    setShowDocumentReplacementModal(false);
  };

  const toggleUploadAttachmentModal = () => {
    setShowAttachmentModal(true);
  };

  function toggleDocumentReplacementModal() {
    setShowDocumentReplacementModal(true);
  };

  //#region document options
  const onDocumentPdfView = async (documentId) => {
    message.warning(notifyMessages.generateDocumentPdfLoading);

    try {
      const respData = await DistinteDocumentServices.readDocumentPDF(documentId);

      if (respData.success) {
        let pdfData = respData.responseObject.value;
        if (pdfData.documentPdfURI) {
          // handle and convert base64 to PDF
          let base64str = pdfData.pdfArray;
          let binary = atob(base64str.replace(/\s/g, ""));
          let len = binary.length;
          let buffer = new ArrayBuffer(len);
          let view = new Uint8Array(buffer);

          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          let blob = new Blob([view], { type: "application/pdf" });
          let url = URL.createObjectURL(blob);
          window.open(url, "Document", "width=800,height=600");
        } else {
          message.error(notifyMessages.noFileFound);
        }
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    }
  };

  const onDocumentPdfReplace = async (file) => {
    const formData = new FormData();
    formData.append("files", file.file.file);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", true);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);
    setLoadingReplaceDocumentPdf(true);
    try {
      const respData = await DistinteDocumentServices.addDocumentAttachment(formData);
      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingReplaceDocumentPdf(false);
        handelModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingReplaceDocumentPdf(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingReplaceDocumentPdf(false);
    }
  };
  //#endregion


  //#region document notes
  const handleAddDocumentNote = async (values) => {

    values["documentID"] = urlParams.id;
    values["userID"] = currentUser.id;

    setLoadingAddNote(true);
    try {
      const respData = await DistinteDocumentServices.addDocumentNote(values);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getDocumentDataByID(urlParams.id, currentUser.id);
        form.resetFields();
        setLoadingAddNote(false);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingAddNote(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingAddNote(false);
    }
  };

  const getDocumentNotesList = async (documentId) => {
    setLoadingNotes(true);
    try {
      const respData = await DistinteDocumentServices.getDocumentNotes(documentId);
      if (respData.success) {
        let result = respData.responseObject.value.documentNotes;
        setDocumentNotes(result);
        setLoadingNotes(false);
      } else {
        setLoadingNotes(false);
      }
    } catch (error) {
      setLoadingNotes(false);
    }
  };

  const onNoteRemove = async (noteId) => {
    setLoadingNoteRemove(true);
    try {
      const respData = await DistinteDocumentServices.removeDocumentNote(noteId);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        getDocumentNotesList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
    } finally {
      setLoadingNoteRemove(false);
    }
  };

  const createExportLogsFile = () => {
    let formatedLogsData = [];

    if (documentNotes && documentNotes.length > 0) {
      setLoadingExportLogs(true);

      documentNotes.map(item => {
        formatedLogsData.push({
          Data: item.operationDate ? moment(item.operationDate).format(dateFormat) : "",
          Messaggio: item.description,
          Utente: item.userName ? `${item.userName}${item.roleName ? ` (${item.roleName})` : ""}` : ""
        });
      });

      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const fileName = `ESPORTAZIONE-LOGs-${moment().format(dateFormat)}`;

      const headers = [["Data", "Messaggio", "Utente"]];
      const ws = XLSX.utils.json_to_sheet([]);


      XLSX.utils.sheet_add_json(ws, formatedLogsData, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_aoa(ws, headers);


      const wb = { Sheets: { 'Logs': ws }, SheetNames: ['Logs'] };

      let wsColsWidthFormatter = [];
      for (let i = 0; i < 25; i++) {
        wsColsWidthFormatter.push({ wpx: 120 })
      }

      for (let key in ws) {
        if (typeof ws[key] !== "object") continue;
        let cell = XLSX.utils.decode_cell(key);
        if (cell.r === 1) {
          let p = key.replace("2", "1");
          ws[p].s = { font: { bold: true } };
        }
      }

      ws['!cols'] = wsColsWidthFormatter;

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
      setLoadingExportLogs(false);
    }
  };
  //#endregion


  //#region document attachments

  const getDocumentAttachmentList = async (documentId) => {
    setLoadingAttachmentList(true);
    try {
      const respData = await DistinteDocumentServices.getDocumentAttachments(documentId);
      if (respData.success) {
        let result = respData.responseObject.value.attachmentList;
        setDocumentAttachments(result.filter(doc => !doc.isInvoicePDF));
        setLoadingAttachmentList(false);
      } else {
        setLoadingAttachmentList(false);
      }
    } catch (error) {
      setLoadingAttachmentList(false);
    }
  };

  const onAttachmentRemove = async (attachmentId) => {
    setLoadingAttachmentDelete(true);
    try {
      const respData = await DistinteDocumentServices.removeDocumentAtachment(attachmentId, currentUser.id);
      if (respData.success) {
        message.success(notifyMessages.operationSuccess);
        setLoadingAttachmentDelete(false);
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingAttachmentDelete(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingAttachmentDelete(false);
    }
  };

  const handelSaveAttachment = async (file) => {
    const formData = new FormData();
    formData.append("files", file.files);
    formData.append("DocumentID", urlParams.id);
    formData.append("isInvoicePDF", false);
    formData.append("UserID", currentUser.id);
    formData.append("calledFromAddDocument", false);

    console.log("formData", formData)
    setLoadingButton(true);
    try {
      const respData = await DistinteDocumentServices.addDocumentAttachment(formData);

      if (respData.success) {
        message.success(notifyMessages.addSuccess);
        setLoadingButton(false);
        handelModalClose();
        getDocumentDataByID(urlParams.id, currentUser.id);
        getDocumentAttachmentList(urlParams.id);
      } else {
        message.error(notifyMessages.errorAccured);
        setLoadingButton(false);
      }
    } catch (error) {
      message.error(notifyMessages.errorAccured);
      setLoadingButton(false);
    }
  };

  //#endregion


  return (
    <div className="document-details">
      <PageHeader title="Visualizzazione documento" />

      {!documentData && <ContentLoader />}

      {documentData && (
        <>

          {showAttachmentModal && (
            <AddDocumentAttachment
              showAttachmentModal={showAttachmentModal}
              handelModalClose={handelModalClose}
              handelSaveAttachment={handelSaveAttachment}
              loadingButton={loadingButton}
              documentData={documentData}
            />
          )}

          {showDocumentReplacementModal &&
            <ReplaceDocumentPdfModal
              showDocumentReplacementModal={showDocumentReplacementModal}
              handelModalClose={handelModalClose}
              onDocumentPdfReplace={onDocumentPdfReplace}
              documentData={documentData}
              loadingReplaceDocumentPdf={loadingReplaceDocumentPdf}
            />
          }

          <Row gutter={{ lg: 24 }}>
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="default"> <Link to={{ pathname: menuLinks.distinte }}> Lista Documenti </Link> </Button>
                  {group2Rights(currentUser) && (
                    <>
                      <Button type="default"> <Link to={{ pathname: `${menuLinks.distinte}/id/${urlParams.id}` }}> Modifica Documento </Link> </Button>
                    </>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
              <Row gutter={{ lg: 24 }} className="mt10">
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                  <Card size="small" className="infoCardv1" title="Dati documento" >
                    <Space direction="vertical" className="docData">
                      <span>  <Text strong> CNA Provinciale: </Text>  <Text>{documentData.regionName} </Text> </span>
                      <span> <Text strong> Mese: </Text> <Text> {documentData.month ? moment(documentData.month).format("MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Data Caricamento: </Text> <Text> {documentData.dateAdded ? moment(documentData.dateAdded).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span> <Text strong> Data Modifica: </Text> <Text> {documentData.lastUpdatedDate ? moment(documentData.lastUpdatedDate).format("DD/MM/YYYY") : ""}</Text> </span>
                      <span>  <Text strong> Utente: </Text>  <Text>{documentData.lastEditedUserName} </Text> </span>
                      <span> <Text strong> Notes: </Text>  <Text>{documentData.notes} </Text> </span>
                      <span> <Text strong> Batch: </Text>  <Text>{documentData.flux} </Text> </span>
                      <span> <Text strong> Tipo: </Text>  <Text>{documentData.documentTypeDistinteName} </Text> </span>
                    </Space>
                  </Card>
                </Col>

                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
                  <Card size="small" className="infoCardv1" title="Altri dati" >
                    <Space direction="vertical" className="docAltriData">
                      <span> <Text strong> Ragione Sociale manutentore: </Text> <Text> {documentData.supplierName} </Text> </span>
                      <span> <Text strong> Partita IVA manutentore: </Text> <Text> {documentData.supplierVatCode} </Text> </span>
                    </Space>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
              <div className="form-save-button-wrapper" style={{ padding: 10 }}>
                <Flex gap="small" wrap>
                  <Button type="primary" onClick={() => onDocumentPdfView(documentData.id)}> Anteprima/Scarica </Button>
                  <Button type="primary" disabled={(documentNotes && documentNotes.length > 0) ? false : true} loading={loadingExportLogs} onClick={createExportLogsFile}> Esporta logs </Button>
                  {group2Rights(currentUser) && (
                    <Button type="primary" onClick={() => toggleDocumentReplacementModal()} icon={<FilePdfOutlined />}> Sostituisci PDF </Button>
                  )}
                </Flex>
              </div>
            </Col>
          </Row>

          <Row gutter={{ lg: 24 }} className="mt10">
            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              <Card size="small" className="infoCardv2" title="Note" >
                <Form form={form} layout="vertical" onFinish={handleAddDocumentNote}>
                  <Form.Item
                    label={<strong>Note:</strong>}
                    name="note"
                    rules={[{ required: true, message: requiredMessages.requiredField }]}
                  >
                    <TextArea rows={4} style={{ width: "100%" }} />
                  </Form.Item>
                  <div className="notes-list">
                    <List
                      loading={loadingNotes}
                      dataSource={documentNotes}
                      renderItem={(note) => (
                        <List.Item className="notes-list-item" actions={[isSuperAdmin(currentUser) && <Button loading={loadingNoteRemove} size="small" type="ghost" icon={<DeleteOutlined />} onClick={() => onNoteRemove(note.id)} />]}>
                          <span className="notes-list-circle">○</span>
                          {/* [{dayjs(note.operationDate).format("ddd D MMM YYYY HH:mm")}] - {note.description} */}
                           [ {<Text strong>{note.operationDate ? dayjs.utc(note.operationDate).tz(dayjs.tz.guess()).format("ddd D MMM YYYY HH:mm") : ""} | {note?.userName}</Text>} ] - {note.description}
                        </List.Item>
                      )}
                    />
                  </div>
                  <div className="filterButtons">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loadingAddNote}
                      icon={<PlusOutlined />}
                    >
                      Aggiungi
                    </Button>
                  </div>
                </Form>
              </Card>
            </Col>

            <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} >
              <Card size="small" className="infoCardv2"
                title={
                  <Space direction="horizontal">
                    <Text>Allegati a questo documento</Text>
                    <>
                      {loadingRemoveAttachment ? <LoadingOutlined /> : ""}
                      <Button
                        onClick={() => toggleUploadAttachmentModal()}
                        size="small"
                        type="primary"
                        shape="circle"
                        icon={<FolderAddOutlined />}
                      />
                    </>
                  </Space>
                }
              >
                {loadingAttachmentList ? (
                  <ContentLoader />  // Show the loader when the list is loading
                ) : (
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {documentAttachment &&
                      documentAttachment.map((item, index) => (
                        <span key={item.id}> <Text className="mr10" strong> {item.attachmentName} </Text>
                          <Button key={item.id + index} className="mr10" size="small" shape="circle" href={item.pathName} icon={<DownloadOutlined />} />
                          {isSuperAdmin(currentUser) && (
                            <Popconfirm
                              title={"Rimuovi questo Attachment?"}
                              onConfirm={() => onAttachmentRemove(item.id)}
                              okText={"Si"}
                              cancelText={"No"}
                            >
                              <Button key={index} size="small" shape="circle" icon={<DeleteOutlined />} />
                            </Popconfirm>
                          )}
                          <Divider style={{ margin: "10px" }} />
                        </span>
                      ))}
                  </Space>
                )}
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default DistinteViewDocument;
